/* eslint-disable */
/* eslint-disable security/detect-object-injection */
/* eslint-disable no-empty-pattern */
import * as yup from "yup";
import * as _ from "lodash";
import regex from "src/helpers/regex";
import { MedicalDetails, ProposerMedicalDetails, familyMedicalData } from "../interfaces";
import { products } from "../../resources";
import { partners } from "src/config/constant";

const initialValues: ProposerMedicalDetails = {
  medicalDetails: {
    declare: true,
    medicalHealth: false,
    weight: "",
    height: {
      centimeter: {
        cm: ""
      },

      inchFeet: {
        inches: "",
        feet: ""
      }
    },
    measurement: "cm",
    familyBackground: false,
    diabetes: false,
    highBloodPressure: false,
    stroke: false,
    asthma: false,
    epilepsy: false,
    liverDisease: false,
    kidneyDisease: false,
    bloodDisorder: false,
    tumor: false,
    anxiety: false,
    aids: false,
    smoker: false,
    cigaratte: false,
    bidi: false,
    cigar: false,
    panMasala: false,
    gutkha: false,
    chewing: false,
    cigaratteAmount: "",
    bidiAmount: "",
    cigarAmount: "",
    panMasalaAmount: "",
    gutkhaAmount: "",
    chewingAmount: "",
    alcohol: false,
    drugs: false,
    disability: false,
    gyneComplications: false,
    pregnant: false,
    pregnancyDuration: "",
    remarks: "",
    beer: false,
    wine: false,
    liquor: false,
    lessThanOnce: false,
    moreThanOnce: false,
    once: false,
    daily: false,
    alcoholAmount: "",
    familyHealthHistory: false,
    familyMedicalHistory: [
      {
        familyPersonName: "",
        familyRelation: "",
        status: "Alive",
        sufferingAge: "",
        ageOfDeath: "",
        presentStateOfHealth: "",
        causeDeath: ""
      }
    ],
    indigestion: false,
    thyroid: false,
    arthritis: false,
    diabetesAndSugar: false,
    bloodPressureHeartAttack: false,
    strokeParalysis: false,
    asthamaTuberculosis: false,
    kidneyStoneBloodUrine: false,
    anaemia: false,
    cancerTumor: false,
    anxietyDepression: false,
    otherDisease: false,
    otherDiseaseDetails: "",
    occupationEnquiry: false,
    alcoholConsumptionSince: 0,
    smokingConsumptionSince: 0,
    existingApplication: false,
    familyHealth: false,
    hospitalisation: false,
    majorDisorder: false,
    underTreatment: false,
    heartDisease: false,
    lungDisease: false,
    highCholesterol: false,
    hivAidsSTI: false,
    congenitalDefect: false,
    genitourinaryHearingVisionDisorder: false,
    paralysis: false,
    brainNervousSystemDisorder: false,
    thyroidDisorder: false,
    chronicDigestiveDisorder: false,
    endocrineDisorder: false,
    anyOtherDisease: "",
    weightLossProgram: false,
    investigateCheckups: false,
    personalConsumptionSmoking: false,
    personalConsumptionTobacco: false,
    personalConsumptionAlcohol: false,
    isOccupationHazardious: false,
    mines: false,
    explosives: false,
    radiation: false,
    corrosiveChemicals: false,
    hobbyQuery: false,
    aviation: false,
    diving: false,
    mountaineering: false,
    seaDiving: false,
    motorRacing: false,
    bungeeJumping: false,
    familyHealthQuery: false,
    femaleOrientedQuery: false,
    personalConsumptionDrugNarcotics: false
  }
};

const validationSchema = (productId: number, age: number, partnerId: string) =>
  yup.object().shape<Record<keyof MedicalDetails, yup.AnySchema>>({
    declare: yup.boolean(),
    medicalHealth: yup.boolean(),
    weight: yup
      .string()
      .required("Required")
      .matches(regex.numericNotZero, "Invalid")
      .max(3, "max 3 digit only"),
    measurement: yup.string(),
    familyBackground: yup.boolean(),
    diabetes: yup.boolean(),
    highBloodPressure: yup.boolean(),
    stroke: yup.boolean(),
    asthma: yup.boolean(),
    epilepsy: yup.boolean(),
    liverDisease: yup.boolean(),
    kidneyDisease: yup.boolean(),
    bloodDisorder: yup.boolean(),
    tumor: yup.boolean(),
    anxiety: yup.boolean(),
    aids: yup.boolean(),
    cigaratte: yup.boolean(),
    bidi: yup.boolean(),
    cigar: yup.boolean(),
    panMasala: yup.boolean(),
    gutkha: yup.boolean(),
    chewing: yup.boolean(),
    smoker: yup.boolean(),
    height: yup.object().shape({
      centimeter: yup.object().shape({
        cm: yup
          .string()
          .test("measurement", "Required", function (value: any, helpers) {
            const { measurement } = helpers.options?.context?.medicalDetails;
            if (measurement === "cm" && !value) {
              return false;
            }
            return true;
          })
          .max(3, "max 3 digit")
          .matches(regex.numericNotZero, "Invalid Height")
      }),
      inchFeet: yup.object().shape({
        inches: yup
          .string()
          .test("measurement-inches", "Required", function (value: any, helpers) {
            const { measurement } = helpers.options?.context?.medicalDetails;
            if (measurement !== "cm" && !value) {
              console.log("inche");
              return false;
            }
            return true;
          })
          .matches(regex.oneToTwelveRange, "Invalid")
          .max(2, "max 2 digit"),
        feet: yup
          .string()
          .test("measurement-feet", "Required", function (value: any, helpers) {
            const { measurement } = helpers.options?.context?.medicalDetails;
            if (measurement !== "cm" && !value) {
              console.log("feet");
              return false;
            }
            return true;
          })
          .matches(regex.numericNotZero, "Invalid")
          .max(1, "max 1 digit")
      })
    }),

    cigaratteAmount: yup
      .string()
      .when("cigaratte", ([cigaratte], schema) =>
        cigaratte
          ? yup
              .string()
              .required("Amount is Required")
              .matches(regex.numericNotZero, "Invalid Amount")
              .max(2, "Enter max 2 digit only")
          : schema
              .notRequired()
              .matches(regex.numericNotZero, "Invalid Amount")
              .max(2, "Enter max 2 digit only")
      ),

    bidiAmount: yup
      .string()
      .when("bidi", ([bidiAmount], schema) =>
        bidiAmount
          ? schema
              .required("Amount is Required")
              .matches(regex.numericNotZero, "Invalid Amount")
              .max(2, "Enter max 2 digit only")
          : schema
              .notRequired()
              .matches(regex.numericNotZero, "Invalid Amount")
              .max(2, "Enter max 2 digit only")
      ),
    cigarAmount: yup
      .string()
      .when("cigar", ([cigarAmount], schema) =>
        cigarAmount
          ? schema
              .required("Amount is Required")
              .matches(regex.numericNotZero, "Invalid Amount")
              .max(2, "Enter max 2 digit only")
          : schema
              .notRequired()
              .matches(regex.numericNotZero, "Invalid Amount")
              .max(2, "Enter max 2 digit only")
      ),
    panMasalaAmount: yup
      .string()
      .when("panMasala", ([panMasalaAmount], schema) =>
        panMasalaAmount
          ? schema
              .required("Amount is Required")
              .matches(regex.numericNotZero, "Invalid Amount")
              .max(2, "Enter max 2 digit only")
          : schema
              .notRequired()
              .matches(regex.numericNotZero, "Invalid Amount")
              .max(2, "Enter max 2 digit only")
      ),
    gutkhaAmount: yup
      .string()
      .when("gutkha", ([gutkhaAmount], schema) =>
        gutkhaAmount
          ? schema
              .required("Amount is Required")
              .matches(regex.numericNotZero, "Invalid Amount")
              .max(2, "Enter max 2 digit only")
          : schema
              .notRequired()
              .matches(regex.numericNotZero, "Invalid Amount")
              .max(2, "Enter max 2 digit only")
      ),
    chewingAmount: yup
      .string()
      .when("chewing", ([chewingAmount], schema) =>
        chewingAmount
          ? schema
              .required("Amount is Required")
              .matches(regex.numericNotZero, "Invalid Amount")
              .max(2, "Enter max 2 digit only")
          : schema
              .notRequired()
              .matches(regex.numericNotZero, "Invalid Amount")
              .max(2, "Enter max 2 digit only")
      ),

    alcohol: yup.boolean(),
    drugs: yup.boolean(),
    disability: yup.boolean(),
    gyneComplications: yup.boolean(),
    pregnant: yup.boolean(),
    pregnancyDuration: yup
      .string()
      .when("pregnant", ([pregnancyDuration], schema) =>
        pregnancyDuration
          ? schema
              .required("Pregnancy Duration is Required")
              .matches(regex.numericNotZero, "Invalid Pregnancy Duration")
              .max(2, "Enter max 2 digit only")
          : schema
              .notRequired()
              .matches(regex.numericNotZero, "Invalid Pregnancy Duration")
              .max(2, "Enter max 2 digit only")
      ),
    remarks: yup
      .string()
      .max(60, "Max 60 characters allowed")
      .matches(regex.alphaNumericWithRestriction, "Invalid values")
      .test("remarks", "Remarks is required", function (value: any, helpers) {
        if (partnerId === partners.JIO) return true;
        const {
          medicalHealth,
          smoker,
          alcohol,
          diabetes,
          stroke,
          asthma,
          epilepsy,
          liverDisease,
          kidneyDisease,
          bloodDisorder,
          tumor,
          anxiety,
          aids,
          familyHealthHistory,
          drugs,
          disability,
          gyneComplications,
          pregnant,
          indigestion,
          thyroid,
          arthritis,
          diabetesAndSugar,
          bloodPressureHeartAttack,
          strokeParalysis,
          asthamaTuberculosis,
          kidneyStoneBloodUrine,
          anaemia,
          cancerTumor,
          anxietyDepression,
          otherDisease,
          occupationEnquiry,
          existingApplication,
          familyHealth,
          hospitalisation,
          majorDisorder,
          underTreatment
        } = helpers.parent;
        if (
          medicalHealth ||
          smoker ||
          alcohol ||
          diabetes ||
          stroke ||
          asthma ||
          epilepsy ||
          liverDisease ||
          kidneyDisease ||
          bloodDisorder ||
          tumor ||
          anxiety ||
          aids ||
          familyHealthHistory ||
          drugs ||
          disability ||
          gyneComplications ||
          pregnant ||
          indigestion ||
          thyroid ||
          arthritis ||
          diabetesAndSugar ||
          bloodPressureHeartAttack ||
          strokeParalysis ||
          asthamaTuberculosis ||
          kidneyStoneBloodUrine ||
          anaemia ||
          cancerTumor ||
          anxietyDepression ||
          otherDisease ||
          occupationEnquiry ||
          existingApplication ||
          familyHealth ||
          hospitalisation ||
          majorDisorder ||
          underTreatment
        ) {
          return value ? true : false;
        }
        return true;
      }),

    beer: yup.boolean(),
    wine: yup.boolean(),
    liquor: yup.boolean(),
    lessThanOnce: yup.boolean(),
    moreThanOnce: yup.boolean(),
    once: yup.boolean(),
    daily: yup.boolean(),
    alcoholAmount: yup
      .string()
      .when("alcohol", ([alcoholAmount], schema) =>
        alcoholAmount
          ? schema
              .required("Amount is Required")
              .matches(regex.numericNotZero, "Invalid Amount")
              .max(2, "Enter max 2 digit only")
          : schema
              .notRequired()
              .matches(regex.numericNotZero, "Invalid Amount")
              .max(2, "Enter max 2 digit only")
      ),
    familyHealthHistory: yup.boolean(),
    familyMedicalHistory: familyMedicalHistoryObject(),
    hospitalisation: yup.boolean(),
    underTreatment: yup.boolean(),
    majorDisorder: yup.boolean(),
    existingApplication: yup.boolean(),
    familyHealth: yup.boolean(),
    smokingConsumptionSince: yup.number().when("smoker", ([smoker], schema) =>
      smoker && [products?.GHS, products?.GHS_FOR_JIO, products?.GHS_IDBI]?.includes(productId)
        ? schema
            .required("Required")
            .min(1, "Min 1 year allowed")
            .max(age || 99, ({ max }) => `Max ${max} years allowed`)
            .integer("Decimal value not allowed")
        : schema.notRequired()
    ),
    alcoholConsumptionSince: yup.number().when("alcohol", ([alcohol], schema) =>
      alcohol && [products?.GHS, products?.GHS_FOR_JIO, products?.GHS_IDBI]?.includes(productId)
        ? schema
            .required("Required")
            .min(1, "Min 1 year allowed")
            .max(age || 99, ({ max }) => `Max ${max} years allowed`)
            .integer("Decimal value not allowed")
        : schema.notRequired()
    ),
    indigestion: yup.boolean(),
    thyroid: yup.boolean(),
    arthritis: yup.boolean(),
    diabetesAndSugar: yup.boolean(),
    bloodPressureHeartAttack: yup.boolean(),
    strokeParalysis: yup.boolean(),
    asthamaTuberculosis: yup.boolean(),
    kidneyStoneBloodUrine: yup.boolean(),
    anaemia: yup.boolean(),
    cancerTumor: yup.boolean(),
    anxietyDepression: yup.boolean(),
    otherDisease: yup.boolean(),
    otherDiseaseDetails: yup
      .string()
      .when("otherDisease", ([otherDisease], schema) =>
        otherDisease &&
        [products?.GHS, products?.GHS_FOR_JIO, products?.GHS_IDBI]?.includes(productId)
          ? schema.required("Required").max(50, ({ max }) => `Max ${max} characters allowed`)
          : schema.notRequired()
      ),
    occupationEnquiry: yup.boolean(),
    heartDisease: yup.boolean(),
    lungDisease: yup.boolean(),
    highCholesterol: yup.boolean(),
    hivAidsSTI: yup.boolean(),
    congenitalDefect: yup.boolean(),
    genitourinaryHearingVisionDisorder: yup.boolean(),
    paralysis: yup.boolean(),
    brainNervousSystemDisorder: yup.boolean(),
    thyroidDisorder: yup.boolean(),
    chronicDigestiveDisorder: yup.boolean(),
    endocrineDisorder: yup.boolean(),
    anyOtherDisease: yup.string(),
    weightLossProgram: yup.boolean(),
    investigateCheckups: yup.boolean(),
    familyHealthQuery: yup.boolean(),
    femaleOrientedQuery: yup.boolean(),
    personalConsumptionSmoking: yup.boolean(),
    personalConsumptionTobacco: yup.boolean(),
    personalConsumptionAlcohol: yup.boolean(),
    isOccupationHazardious: yup.boolean(),
    mines: yup.boolean(),
    explosives: yup.boolean(),
    radiation: yup.boolean(),
    corrosiveChemicals: yup.boolean(),
    hobbyQuery: yup.boolean(),
    aviation: yup.boolean(),
    diving: yup.boolean(),
    mountaineering: yup.boolean(),
    seaDiving: yup.boolean(),
    motorRacing: yup.boolean(),
    bungeeJumping: yup.boolean(),
    personalConsumptionDrugNarcotics: yup.boolean(),
    femalePregnanacyQuery: yup.boolean()
  });

const familyMedicalHistoryObject = () =>
  yup.array().when("familyHealthHistory", {
    is: true,
    then: (schema) =>
      schema.of(
        yup.object().shape<Record<keyof familyMedicalData, yup.AnySchema>>({
          sufferingAge: yup
            .string()
            .when("status", ([status], schema) =>
              status == "Alive"
                ? schema
                    .required("Age is Required")
                    .matches(regex.digits, "Invalid Age")
                    .max(2, "Maximum 2 characters allowed")
                : schema
                    .notRequired()
                    .matches(regex.digits, "Invalid Age")
                    .max(2, "Maximum 2 characters allowed")
            ),
          ageOfDeath: yup
            .string()
            .when("status", ([status], schema) =>
              status == "Deceased"
                ? schema
                    .required("Age is Required")
                    .matches(regex.digits, "Invalid Age")
                    .max(2, "Maximum 2 characters allowed")
                : schema
                    .notRequired()
                    .matches(regex.digits, "Invalid Age")
                    .max(2, "Maximum 2 characters allowed")
            ),
          presentStateOfHealth: yup
            .string()
            .when("status", ([status], schema) =>
              status == "Alive"
                ? schema.required("Present State is Required")
                : schema.notRequired()
            ),
          familyPersonName: yup
            .string()
            .required("Name is Required")
            // .matches(regex.alphabetWithSpace, "Only alphabets allowed")
            .matches(regex.fullName, "Invalid Name Of Person")
            .max(60, "Maximum 60 characters allowed"),
          familyRelation: yup.string().required("Family Relation is required"),
          status: yup.string().required("Status is required"),
          causeDeath: yup
            .string()
            .when("status", ([status], schema) =>
              status == "Deceased"
                ? schema.required("Cause of death is Required")
                : schema.notRequired()
            )
        })
      ),
    otherwise: (schema) => schema.notRequired()
  });

const ProperdetailMedicalSchema = (productId: number, age: number, partnerId: string) =>
  yup.object().shape<Record<keyof ProposerMedicalDetails, yup.AnySchema>>({
    medicalDetails: validationSchema(productId, age, partnerId)
  });
const getFieldValues = (fieldValues: any) => {
  console.log(fieldValues);
};

const constructValidationSchema = (data: any, { showIf = {} } = {}, logical = "AND") => {
  // console.log("values", data, showIf);
  let schema: any = yup.string();
  if (data?.type === "switch" || data?.type === "checkbox") schema = yup.boolean();

  if (data?.type === "number") schema = yup.number();

  if (Object.keys(showIf)?.length > 0) {
    const keys = Object.keys(showIf || {});
    schema = schema.when(keys, (keys: any[], schema: any) => {
      // console.log("validation schema", showIf, keys, logical);
      return (
        logical === "OR"
          ? _.intersection(
              keys?.map((k) => k?.toString()),
              Object?.values(showIf || {})?.map((k) => k?.toString())
            )?.length > 0
          : _.isEqual(
              keys?.map((k) => k?.toString()),
              Object?.values(showIf || {})?.map((k) => k?.toString())
            )
      )
        ? schema?.required(data?.message || "This field is required")
        : schema.notRequired();
    });
  } else if (data?.required) schema = schema?.required(data?.message || "This field is required");

  if (data?.min) {
    schema = schema?.min(data?.min, ({ min }: { min: number }) => `Minimum ${min} required`);
  }

  if (data?.max) {
    schema = schema?.max(data?.max, ({ max }: { max: number }) => `Maximum ${max} allowed`);
  }

  if (data?.regex) {
    schema = schema.matches(new RegExp(data?.regex), data?.regexErrorMessage || "Invalid value");
  }

  return schema;
};

export {
  initialValues,
  validationSchema,
  ProperdetailMedicalSchema,
  getFieldValues,
  constructValidationSchema
};
